import { OptionKey } from '../option';
import { CycleHighestMetrics } from '../types/screen-cycle-table';

export const CELSIUS_TEMPERATURE_DIFF_THRESHOLD = 15;

const replaceBorderClasses = (original: string, newClass: string) => {
  const borderIndex = original.indexOf(newClass);
  if (borderIndex === -1) {
    return `${original} border ${newClass}`;
  }

  return `${original.slice(0, borderIndex)}`;
}

const getTemperatureBorderClass = (optionKey: string, cycle: CycleHighestMetrics, currentClassName: string, tempDiffThreshold: number): string | undefined => {
  if (optionKey !== OptionKey.LOWEST_TEMP && optionKey !== OptionKey.HIGHEST_TEMP) {
    return;
  }

  const tempValue = optionKey === OptionKey.LOWEST_TEMP ? Number(cycle.lowest_temp) : Number(cycle.highest_temp);

  const spValue = Number(cycle.highest_sp);
  const difference = tempValue - spValue;

  if (difference > tempDiffThreshold) {
    const className = 'border border-red';
    return replaceBorderClasses(currentClassName, className);
  };
  if (difference < -tempDiffThreshold) {
    const className = 'border border-blue-600';
    return replaceBorderClasses(currentClassName, className);
  };

  return '';
};

export default getTemperatureBorderClass;
